import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: e = 16, useVw: l, useRem: o, color: n, withColor: c, removeClassName: t, disableSSR: m, style: r, ...p }) => {
  const h = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-zhibo", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), height: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-ç´æ­"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: c ? i(n, 0, "#262933") : "#262933",
        datafollowfill: c ? i(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M9.55 3.39a.9.9 0 0 1 1.192.449l1.59 3.511h5.555l1.59-3.511a.9.9 0 1 1 1.64.742l-1.254 2.77h1.624a4.687 4.687 0 0 1 4.687 4.686.9.9 0 0 1-1.8 0 2.887 2.887 0 0 0-2.887-2.887h-3a.9.9 0 0 1-.04 0H8.482a2.887 2.887 0 0 0-2.888 2.888v10.1a2.887 2.887 0 0 0 2.888 2.887h4.797a.9.9 0 0 1 0 1.8H8.483a4.687 4.687 0 0 1-4.688-4.688v-10.1A4.687 4.687 0 0 1 8.483 7.35h1.873L9.102 4.581a.9.9 0 0 1 .449-1.19Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M12.27 14.638v4.533c0 .589.642.953 1.147.65l3.778-2.267a.757.757 0 0 0 0-1.299l-3.778-2.267a.757.757 0 0 0-1.147.65Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M28.26 17.96a4.047 4.047 0 1 0-7.974 1.388l-.743 1.328-2.651 4.739a1.17 1.17 0 0 0 .33 1.532l1.5 1.079a1.17 1.17 0 0 0 1.566-.183l.009-.01 4.366-5.195a4.047 4.047 0 0 0 3.597-4.679Zm-5.567 4.38a4.067 4.067 0 0 1-1.512-1.109l-.154.275-2.427 4.338.715.514 3.378-4.018Zm1.195-6.046a2.347 2.347 0 1 1 .755 4.633 2.347 2.347 0 0 1-.755-4.633Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, g = f;
export {
  g as default
};
